export default __webpack_public_path__ + "static/media/IconDesc_HazmatFilter.64.5bd3a6d7.png";